import { useTranslation } from "@flare/i18n";
import { Heading, Text } from "@flare/ui/components";

export function LssIntroDialogContent() {
  const { t } = useTranslation();

  return (
    <div className="mb-sp-2 space-y-sp-6">
      <div className="mt-sp-9 space-y-sp-4">
        <Heading variant="h3" className="mt-sp-6">
          {t("FUNNEL_STEP_LSS_INTRO_DIALOG_TITLE")}
        </Heading>
        <Text>{t("FUNNEL_STEP_LSS_INTRO_DIALOG_SUBTITLE")}</Text>
      </div>
      <video
        height="auto"
        width="100%"
        autoPlay
        controls
        muted
        className="rounded-md border border-primary"
      >
        <source
          src="https://cdn.builder.io/o/assets%2F15f74e88630d41b6b43ece1273087b6f%2F9307f56cabad4c1e9dfba05ca7d16406%2Fcompressed?apiKey=15f74e88630d41b6b43ece1273087b6f&token=9307f56cabad4c1e9dfba05ca7d16406&alt=media&optimized=true"
          type="video/mp4"
        ></source>
      </video>
    </div>
  );
}
